import React from "react"
import {Link} from "react-router-dom"
import {Button, Segment} from "semantic-ui-react"
import {useTranslation, Trans} from "react-i18next";

const SignaturesOverview = ({ signatures }) => {
  const { t } = useTranslation();
  return (
    <div>  { signatures.length && <div>
      <h3 className="white">{t("signature.open")}</h3>
      {signatures.map( step => <SignatureSegment key={step.Id} step={step}/> )}
    </div>}</div>
  )
}

const SignatureSegment = ({ step }) => {
  if ( step.TrackingId === "EXTRA_SIG_EXTERNAL_TECH" ) return null
  let signatureNow = <Trans i18nKey="signature.now">jetzt unterschreiben</Trans>
  let signatureNo = <Trans i18nKey="signature.onlyNo">keine Unterschrift vorhanden</Trans>
  let done = <Trans i18nKey="general.done">erledigt</Trans>
  return (
    <Segment>
      <h4 className="pb2">{step.Name}</h4>
      {!step.IsDone && <div><Button title={<signatureNow/>} as={Link} to={`/tasks/${step.Id}`} icon="pencil"/> <signatureNo/></div> }
      {step.IsDone && <div><Button color="green" icon="checkmark"/>{step.Data.TimeStamp || <done/>}</div>}
      {/*<pre>{JSON.stringify( step, null, 2 )}</pre>*/}
    </Segment>
  )
}

export default SignaturesOverview



// WEBPACK FOOTER //
// ./src/pages/components/SignaturesOverview.js